import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {Button, Input, Spacer, Toggle} from "@dspworkplace/ui";

export default function PaycomSettingsV2({  initialValues = false, onSubmit }) {
    const { register, handleSubmit, errors, reset, watch } = useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => { if (initialValues) reset(initialValues) }, [initialValues]);

    const handleSave = async (data) => {
        data.credentials = {}
        data.credentials.username = data.clientId
        data.credentials.password = data.clientSecret

        delete data.clientId
        delete data.clientSecret

        setLoading(true)

        onSubmit(data)
    }

    return <section>
        <form onSubmit={handleSubmit(handleSave)}>
            <input type='hidden' name='id' ref={register} autoComplete="off" />
            <input type='hidden' value='PAYCOM' name='integration_type' ref={register} autoComplete="off" />
            <Input
                ref={register({ required: true })}
                name='name'
                label='Account name'
                Required={true}
                invalid={errors && errors.name}
                error={errors && errors.name && 'Required field'}
                autoComplete="off"
                help={'You can have multiple accounts, so this helps to identify to which account is supplying the data'}
            />
            <Spacer bottom={3} />
            <Toggle
                ref={register}
                name='enabled'
                singleText="Enable this account"
            />
            <Spacer bottom={3} />
            <Toggle
                ref={register}
                name="syncTimeOff"
                // help="If this is enabled, the system will automatically fetch ADP punch data."
                singleText="Enable TimeOff Sync"
            />
            <Spacer bottom={3} />
            <Input
                ref={register({
                    required: true
                })}
                name='clientId'
                label='Client Id'
                Required={true}
                valid={(!errors || !errors.clientId)}
                invalid={errors && errors.clientId}
                error={errors && errors.clientId && 'Required field'}
                autoComplete="off"
            />
            <Spacer bottom={3} />
            <Input
                ref={register({
                    required: true
                })}
                name='clientSecret'
                label='Client Secret'
                Required={true}
                valid={(!errors || !errors.clientSecret)}
                invalid={errors && errors.clientSecret}
                error={errors && errors.clientSecret && 'Required field'}
                autoComplete="off"
            />
            <Spacer bottom={5} />

            <Button
                type='primary'
                disabled={loading}
            >
                {!loading ? 'Save' : 'Saving...'}
            </Button>
        </form>
    </section>
}